var _rect, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMexcLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 92,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.8701 53.8346L62.4921 30.629C59.5592 25.7923 52.4071 25.7409 49.5771 30.8348L35.5304 54.9666C32.9062 59.3916 36.1477 64.9485 41.3961 64.9485H69.5412C74.841 64.9485 78.8029 59.2371 75.8701 53.8346Z",
    fill: "#3156AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5748 55.6356L55.7516 54.1949C54.9799 52.857 53.2818 49.9756 53.2818 49.9756L41.962 30.3204C39.0292 25.9468 32.083 25.5866 29.1501 31.0922L15.978 53.8861C13.251 58.6713 16.4925 64.8971 22.4097 64.9488H50.4004H62.3377H69.4384C62.1834 65.0002 59.8681 61.2439 56.5748 55.6356Z",
    fill: "#1972E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5755 55.6354L55.7523 54.1949C54.9805 52.857 53.2825 49.9756 53.2825 49.9756L45.9761 37.1122L35.4795 55.0181C32.8555 59.4431 36.097 65 41.3454 65H50.3496H62.2869H69.439C62.1326 64.9486 59.8685 61.244 56.5755 55.6354Z",
    fill: "url(#paint0_linear_11842_6654)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11842_6654",
    x1: 31.7439,
    y1: 46.8822,
    x2: 64.2616,
    y2: 58.8988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#264CA2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#234588"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMexcLogo);
export default __webpack_public_path__ + "static/media/mexc-logo.490fa34efc58adcdf029e969d575c518.svg";
export { ForwardRef as ReactComponent };